import i18next from 'i18next';
import * as Yup from 'yup';

export const addNewAddressValidationSchema = Yup.object().shape({
  CountryIso3Code: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.countryIsRequired'),
  ),
  AddressLine: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.addressIsRequired'),
  ),
  City: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.cityIsRequired'),
  ),
  StateRegion: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.stateRegionIsRequired'),
  ),
  PostalCode: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.PostalCodeIsRequired'),
  ),
  TagType: Yup.number()
    .required(
      i18next.t('validationSchema.addCreditCardValidation.tagIsRequired'),
    )
    .oneOf(
      [1, 2, 3],
      i18next.t('validationSchema.addCreditCardValidation.tagIsInvalid'),
    ),
  CustomTagName: Yup.string().when('TagType', {
    is: 3,
    then: Yup.string()
      .trim()
      .required(
        i18next.t(
          'validationSchema.addCreditCardValidation.customTagIsRequired',
        ),
      ),
    otherwise: Yup.string().nullable(),
  }),
});

export const addNewBankAddressValidationSchema = Yup.object().shape({
  CountryIso3Code: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.countryIsRequired'),
  ),
  AddressLine: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.addressIsRequired'),
  ),
  City: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.cityIsRequired'),
  ),
  StateRegion: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.stateRegionIsRequired'),
  ),
  PostalCode: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.PostalCodeIsRequired'),
  ),
});
